import DEFAULT_AVATAR from 'images/endUserAvatar.svg'
import { pathOr } from 'ramda'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const useUserResolution = () => {
  const { t } = useTranslation()
  const endUser = useSelector(state => (
    state.session.endUser
  ))

  return useMemo(() => {
    return {
      id: endUser.id,
      name: pathOr(t('user.self'), ['name'], endUser),
      avatar: pathOr(DEFAULT_AVATAR, ['socialProfile', 'avatar'], endUser),
      email: pathOr(null, ['socialProfile', 'email'], endUser)
    }
  }, [endUser, t])
}

export default useUserResolution
